<template>
  <div class="vx-row">
    <div class="w-full vx-col" v-can="'view-shipping-costs-setting'">
      <vx-card :title="'SHIPPING COST FOR PRICING (GBP/KG)'" class="">
        <div id="shipping-cost-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe class="mt-8" noDataText="">
              <template slot="thead">
                <vs-th>REGION</vs-th>
                <vs-th v-for="(fg_type) in allFgTypes" :key="fg_type">
                  <span style="text-transform: uppercase !important;">{{ fg_type }}</span>
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr v-for="(region, index) in regions" :key="'region-' + index">
                  <vs-th><span style="text-transform: uppercase !important;">{{ region.name }}</span></vs-th>
                  <vs-td v-for="(fg_type, colIndex) in allFgTypes" :key="'fg-' + colIndex">
                    <div class="flex items-center">
                      <span class="mr-4 mt-1 font-medium">
                        {{ generateSundryCost(fg_type, region) }}
                      </span>
                      <vx-tooltip :text="`Add/Update cost`" position="left" v-can="'edit-shipping-costs-setting'">
                        <vs-button size="small" icon-pack="feather"
                          @click.stop="onClickAddUpdateCost(fg_type, region)"
                          :color="!!generateSundryCost(fg_type, region) ? 'warning' : 'primary'"
                          :icon="!!generateSundryCost(fg_type, region) ? 'icon-edit' : 'icon-plus'"
                          type="border"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left" v-if="!!generateSundryCost(fg_type, region)"
                        v-can="'edit-shipping-costs-setting'">
                        <vs-button @click.stop="openConfirm(fg_type, region)" class="ml-3" size="small"
                          color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <add-new-shipping-cost-pop-up ref="addNewShippingCostPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewShippingCostPopUp from '@/components/popups/settings/shipping-cost/AddNewShippingCostPopUp.vue';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
const ShippingCostRepository = RepositoryFactory.get('shipping_cost');
const RegionsRepository = RepositoryFactory.get('regions');

export default {
  name: "ShippingCostListSettings",
  data() {
    return {
      shipping_cost_list: [],
      regions: [],
      fg_types: ['powder', 'liquid', 'spray dry powder', 'fruit']
    }
  },
  computed: {
    allFgTypes() {
      const baseTypes = this.fg_types || ['powder', 'liquid', 'spray dry powder', 'fruit'];
      const fromList = (this.shipping_cost_list || [])
        .map(x => (x.formulation_type ? x.formulation_type.toLowerCase() : ''))
        .filter(Boolean);
      return Array.from(new Set([...baseTypes, ...fromList]));
    }
  },
  components: {
    AddNewShippingCostPopUp
  },
  methods: {
    async refreshData() {
      await Promise.all([
        this.fetchRegions(),
        this.fetchShippingCostList()
      ]);
    },
    async fetchRegions() {
      try {
        const response = await RegionsRepository.fetchRegionsWithoutPagination();
        this.regions = response.data.data || response.data || [];
      } catch (e) {
        this.convertAndNotifyError(e);
      }
    },
    async fetchShippingCostList() {
      await this.$vs.loading({
        container: '#shipping-cost-list-table',
        scale: 0.45
      })
      try {
        const { data } = await ShippingCostRepository.getShippingCostList(1, '', defaultPagination, '', 0);
        this.shipping_cost_list = data.data || data || [];
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close('#shipping-cost-list-table > .con-vs-loading')
    },
    findShippingCost(fg_type, region) {
      const fg = (fg_type || '').toLowerCase();
      const regionId = region && typeof region === 'object' ? region.id : region;
      const regionName = region && typeof region === 'object' ? (region.name || '').toLowerCase() : (region || '').toLowerCase();

      return this.shipping_cost_list.find((x) => {
        const itemFg = (x.formulation_type || '').toLowerCase();
        if (itemFg !== fg) return false;

        if (x.region && typeof x.region === 'object') {
          if (regionId && x.region.id === regionId) return true;
          if (regionName && (x.region.name || '').toLowerCase() === regionName) return true;
        } else if (x.region_id && regionId && x.region_id === regionId) {
          return true;
        } else if (typeof x.region === 'string') {
          if (regionName && x.region.toLowerCase() === regionName) return true;
        }
        return false;
      });
    },
    generateSundryCost(fg_type, region) {
      const find = this.findShippingCost(fg_type, region);
      return find && find.cost !== null && find.cost !== undefined && find.cost !== '' ? Number(find.cost).toFixed(2) : null;
    },
    openConfirm(fg_type, region) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [fg_type, region]
      })
    },
    async onClickDelete(params) {
      try {
        const [fg_type, region] = params;
        const find = this.findShippingCost(fg_type, region);
        if (find && find.id) {
          await ShippingCostRepository.deleteShippingCost(find.id);
          await this.fetchShippingCostList();
          await this.showSuccessMessage('Shipping cost deleted!');
        }
      } catch (e) {
        this.convertAndNotifyError(e);
      }
    },
    async onClickAddUpdateCost(fg_type, region) {
      const find = this.findShippingCost(fg_type, region);
      if (find && find.id) {
        await this.$refs.addNewShippingCostPopUp.openPopup(find.id, fg_type, region);
      } else {
        await this.$refs.addNewShippingCostPopUp.openPopup(null, fg_type, region);
      }
    }
  },
  async mounted() {
    await this.fetchRegions();
    await this.fetchShippingCostList();
  },
  mixins: [Filter, SuccessMessage, ErrorMessages]
}
</script>

<style scoped></style>
